import Controller from "./topups.controller";
import template from "./topups.html";

const topups = {
  template,
  controller: Controller,
};

export default topups;



// WEBPACK FOOTER //
// ./src/pages/topups/topups.component.js